import { render, staticRenderFns } from "./industryServe.vue?vue&type=template&id=1f124d58&scoped=true&"
import script from "./industryServe.vue?vue&type=script&lang=js&"
export * from "./industryServe.vue?vue&type=script&lang=js&"
import style0 from "./industryServe.vue?vue&type=style&index=0&id=1f124d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f124d58",
  null
  
)

export default component.exports